import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ErrorBoundary } from 'react-error-boundary';
import { Provider } from 'react-redux';
import store from './services/store';
import ErrorFallback from './pages/Errors/ErrorFallback';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <ErrorBoundary FallbackComponent={ErrorFallback}>
    <Provider store={store}>
      <App />
    </Provider>
  </ErrorBoundary>
);
